import { Menu, Text } from '@mantine/core';
import { Icon } from '@uag/react-core';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/shallow';

import { ShortcutAction } from 'app/modules/wallforming/components/scenes/toolbar/types/shortcutAction';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

export const Rotate = () => {
    const { t } = useTranslation();

    const { articleInstanceSelections, handleOnArticleDefaultRotation } = usePlacementStore(
        useShallow((state) => ({
            articleInstanceSelections: state.articleInstanceSelections,
            handleOnArticleDefaultRotation: state.handleOnArticleDefaultRotation
        }))
    );

    const hasSelection = (() => {
        for (const _ in articleInstanceSelections) {
            return true;
        }
        return false;
    })();

    return (
        <Menu.Item
            disabled={!hasSelection}
            leftSection={
                <Icon
                    className="action-menu-entry-decoration action-menu-entry-decoration-icon"
                    icon="rotate_90_degrees_cw"
                />
            }
            rightSection={<Text className="action-menu-entry-decoration-text text-right text-[13px]">{ShortcutAction.Rotate}</Text>}
            onClick={() => handleOnArticleDefaultRotation()}
        >
            {t('rotate')}
        </Menu.Item>
    );
};
